import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let submit = useDataSubmit({
    context: 'provider_accounts',
    viewPath: props.viewPath,
  })
  let provider_account = useDataValue({
    context: 'provider_account',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    submit({
      type: 'save_settings',
      account_id: provider_account.account_id,
      is_pay_app_enabled: provider_account.greyfinch_pay_app_enabled,
      fee_mode: provider_account.fee_mode,
      card_fee_percent: provider_account.card_fee_percent,
      ach_fee_percent: provider_account.ach_fee_percent,
      fee_acknowledged_by_user_id: value.fee_acknowledged_by_user_id,
    })

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
